import {
  useErrorHandlerContext,
  useOpeningElementsControllerContext,
  useUserLanguage,
} from '@/customHooks'
import { useMemo, useState } from 'react'
import textsData from '@/textData/CreateContractsTexts.json'
import styled from 'styled-components'
import { Col, Container, Row } from 'react-grid-system'
import { Stepper } from '../molecules'
import { Button } from '../atoms'
import { useNavigate } from 'react-router'
import { useCreateContractContext } from '@/customHooks/useCreateContractContext'
import { FetchResult } from '@apollo/client'
import { CreateContractMutation, useCreateContractMutation } from '@/graphql/generated'
import { CreateContractTemplate } from '../templates'

const StepperContainer = styled(Col)`
  display: flex;
  justify-content: center;
  padding-top: ${({ theme }) => theme.spacing.md};
  padding-bottom: ${({ theme }) => theme.spacing.md};
`;

const ButtonsContainer = styled(Row)`
  margin-top: 3rem;
  margin-bottom: 2rem;
`;

export const CreateContractPage = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en;

  const [currentPage, setCurrentPage] = useState(0);

  const steps = useMemo(
    () => texts.templateText.map((element) => element.step),
    [texts],
  );

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext();

  const navigate = useNavigate();

  const { state, buttonState } = useCreateContractContext();

  const { open: errorHandle } = useErrorHandlerContext();

  const [createContract, { loading }] = useCreateContractMutation();

  const onSuccesHandle = (response: FetchResult<CreateContractMutation>) => {
    confirmDialogModalOpen({
      title: texts.confirmationModal.title,
      description: `${texts.confirmationModal.description} ${response.data?.createContract.id}`,
    });
    navigate(-1);
  };

  const onFinishHandle = () => {
    createContract({
      variables: {
        input: {
          ...state,
          signed: false,
        },
      },
    })
      .then(onSuccesHandle)
      .catch(errorHandle);
  };

  return (
    <Container>
      <Row>
        <StepperContainer>
          <Stepper
            steps={steps}
            currentStep={currentPage}
          />
        </StepperContainer>
      </Row>

      <CreateContractTemplate 
        currentTemplate={currentPage} 
      />
      
      <ButtonsContainer justify="center">
        <Col xs="content">
          <Button
            secondary
            onClick={() => {
              if (currentPage > 0) setCurrentPage((prev) => prev - 1);
              else navigate(-1);
            }}
          >
            {texts.cancelButton}
          </Button>
        </Col>
        <Col xs="content">
          <Button
            onClick={() => {
              if (currentPage < steps.length - 1) setCurrentPage((prev) => prev + 1);
              else onFinishHandle();
            }}
            disabled={buttonState}
            isLoading={loading}
          >
            {texts.confirmButton}
          </Button>
        </Col>
      </ButtonsContainer>
    </Container>
  );
};
